import React, { memo } from "react";
import "./EmployeeDetailsCollapsible.css";
import { formatPersonDisplayName } from "../../../utils/personnelDisplay";

const EmployeeDetailsCollapsible = ({
  employee,
  getUnitName,
  formatBooleanValue,
  collapsed,
  onToggle,
}) => (
  <div className="employee-details-section">
    <div
      className="employee-details-header"
      onClick={onToggle}
      style={{ cursor: "pointer" }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <h3>פרטי החייל</h3>
      <span
        className={`details-toggle-arrow ${collapsed ? "collapsed" : "expanded"}`}
      >
        ▼
      </span>
    </div>
    {!collapsed && (
      <>
        <div className="employee-details-grid">
          <div className="detail-item">
            <span className="detail-label">שם מלא:</span>
            <span className="detail-value">
              {formatPersonDisplayName(employee)}
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">מ.א:</span>
            <span className="detail-value">{employee.personalNumber}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">יחידה:</span>
            <span className="detail-value">{getUnitName(employee.unitId)}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">טלפון:</span>
            <span className="detail-value">{employee.phone || "לא מוגדר"}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">דרגה:</span>
            <span className="detail-value">{employee.rank || "לא מוגדר"}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">מסופח:</span>
            <span className="detail-value">
              {formatBooleanValue(employee.isAttached)}
            </span>
          </div>
          <div className="detail-item">
            <span className="detail-label">משקש:</span>
            <span className="detail-value">
              {formatBooleanValue(employee.isSecret)}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
);

export default memo(EmployeeDetailsCollapsible);
